import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Formatter, { dateTimeFormats, numberFormats } from '@/configs/formatter/config'
import localeFr from '~locales/fr.json'

Vue.use(VueI18n)

const locales = {
  'fr-FR': localeFr,
}
const defaultLocale = Object.keys(locales)[0]

const formatter = new Formatter({ locale: defaultLocale, })

export default new VueI18n({
  locale: defaultLocale,
  fallbackLocale: defaultLocale,
  formatter,
  messages: locales,
  dateTimeFormats,
  numberFormats,
})
